import React, { useEffect, useState } from "react";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import TeamService from "services/TeamService";
import TimeFilter from "components/TimeFilter";
import TeamVideoStatsDetailCard from "./TeamVideoStatsDetailCard";
import TeamVideoStatsDetailCardMainPage from "./TeamVideoStatsDetailCardMainPage";
import Scrollbar from "react-scrollbars-custom";

const styles = {
  detailsContainer: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  loadMoreButton: {
    textAlign: "center",
  },
  timeFilter: {
    height: "35px",
  },
  detailCardContainer: {
    display: "flex",
    flex: 1,
    overflow: "auto",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ showPublishVideo, opened, team_id, time, setTime }) => {
  const classes = styles;
  const [loading, setLoading] = useState(true);
  const [teamVideos, setTeamVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState("");

  useEffect(() => {
    if (!opened) {
      setTeamVideos([]);
      setPage(1);
      setLoading(true);

      return;
    }

    (async () => {
      setLoading(true);

      try {
        const response = await TeamService.getTeamVideos(team_id, time, page);
        setTeamVideos(
          Array.from(new Set([...teamVideos, ...response.data.data]))
        );
        setTotal(response?.data?.meta?.total);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [opened, team_id, page, time]);

  if (!opened) {
    return <Loader loaderStyle={classes.loaderStyle} />;
  }

  const updateTime = (updatedTime) => {
    setTeamVideos([]);
    setTime(updatedTime);
    setPage(1);
  };

  const getNextPageData = () => {
    setLoading(true);
    setPage(page + 1);
  };

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.LoaderStyle} />
        </h4>
      )}
      {!loading && total !== teamVideos.length && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <div style={classes.detailsContainer}>
      <div style={classes.timeFilter}>
        <TimeFilter time={time} setTime={updateTime} color={"black"} />
      </div>
      <div style={classes.detailCardContainer}>
        <Scrollbar>
          {showPublishVideo &&
            teamVideos.map((teamVideo) => (
              <TeamVideoStatsDetailCard
                key={teamVideo.id}
                teamVideo={teamVideo}
              />
            ))}
          {!showPublishVideo &&
            teamVideos.map((teamVideo) => (
              <TeamVideoStatsDetailCardMainPage
                key={teamVideo.id}
                teamVideo={teamVideo}
              />
            ))}
          {LoadingContainer}
        </Scrollbar>
      </div>
    </div>
  );
};
